export default __webpack_public_path__ + "media/images/logo_full_imastodon-248151d9fe94e567b55e49a454fac10b.svg";